import React from "react";
import { Link } from "react-router-dom";

function PortfolioTwo() {
  return (
    <div>
      {/* Start Portfolio area  */}
      <div className="portfolio-area portfolio-style-two tmp-section-gap">

        <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-head">
              <div className="section-sub-title center-title">
                <img
                  src="assets/images/services/section-custom-menubar.png"
                  alt="Corporate services"
                />
                <span>Our Gallery</span>
              </div>
              <h2 className="section-title split-collab">
              Captured Moments of Excellence

              </h2>
            </div>
          </div>
        </div>
          <div className="row g-5">
            {[
              {
                img: "portfolio-two-2.png",
                // name: "Doris Sharp",
                // role: "Chief Architect",
              },
              {
                img: "portfolio-two-3.png",
                // name: "Sharon Willis",
                // role: "Software Engineer",
              },
              {
                img: "portfolio-two-4.png",
                // name: "Gina Larsen",
                // role: "Product Manager",
              },
            ].map((item, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div
                  className="portfolio-inner"
                  data-tmp-cursor="lg"
                  data-tmp-cursor-text="View Details"
                >
                  <a   className="thumbnail">
                    <img
                      src={`assets/images/portfolio/${item.img}`}
                      alt="corporate business"
                    />
                  </a>
                  {/* <div className="portfolio-tag portfolio-md-tag">
                    <div className="content">
                      <Link to={"/ProjectDetails"}>
                        <h3 className="name">{item.name}</h3>
                      </Link>
                      <div className="designation">{item.role}</div>
                    </div>
                     <Link
                      to={"/ProjectDetails"}
                      className="icon icon--30 radius-circle border-none bg-color-white"
                    >
                      <i className="fa-solid fa-arrow-right transform-rotate-318" />
                    </Link>  
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Start Portfolio area  */}
    </div>
  );
}

export default PortfolioTwo;
